import { configs } from "configs"
const getLeadInitialValues = () => {
  return {
    project: null,
    leadType: null,
    propertyType: "", //TODO: to be fixed by BE
    subType: null, //TODO: to be fixed by BE
    classification: "",
    source: null,
  }
}

export default getLeadInitialValues
